// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1i1dI","questions":"styles_questions__2QjjI","footer":"styles_footer__p48_D"};